import { createLocalStore } from 'stencil-store-storage';
// import { v4 as uuidv4 } from 'uuid/dist/esm-browser/';
import { v4 as uuidv4 } from 'uuid';

const { state } = createLocalStore('onsitesearch', {
  uuid: uuidv4(),
  rand: Math.random(),
});

export default state;
